var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD2CEcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11349_21523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1733 15.3333H17.6533L17.3067 12.88C17.1943 12.0824 16.7981 11.352 16.1907 10.823C15.5833 10.294 14.8055 10.0018 14 10H11.6533V11.3333H14C15 11.3333 15.84 12.08 15.9867 13.0533L18.68 32.4533C18.7923 33.251 19.1885 33.9813 19.7959 34.5103C20.4033 35.0394 21.1812 35.3316 21.9867 35.3333H37V34H21.9867C20.9867 34 20.1467 33.2533 20 32.28L19.68 30H37.2267L40.16 15.3333H40.1733ZM19.5067 28.6667L17.84 16.6667H38.5467L36.1467 28.6667H19.5067ZM21 36.6667C19.5333 36.6667 18.3333 37.8667 18.3333 39.3333C18.3333 40.8 19.5333 42 21 42C22.4667 42 23.6667 40.8 23.6667 39.3333C23.6667 37.8667 22.4667 36.6667 21 36.6667ZM21 40.6667C20.2667 40.6667 19.6667 40.0667 19.6667 39.3333C19.6667 38.6 20.2667 38 21 38C21.7333 38 22.3333 38.6 22.3333 39.3333C22.3333 40.0667 21.7333 40.6667 21 40.6667ZM33 36.6667C31.5333 36.6667 30.3333 37.8667 30.3333 39.3333C30.3333 40.8 31.5333 42 33 42C34.4667 42 35.6667 40.8 35.6667 39.3333C35.6667 37.8667 34.4667 36.6667 33 36.6667ZM33 40.6667C32.2667 40.6667 31.6667 40.0667 31.6667 39.3333C31.6667 38.6 32.2667 38 33 38C33.7333 38 34.3333 38.6 34.3333 39.3333C34.3333 40.0667 33.7333 40.6667 33 40.6667ZM13.9867 18H9V16.6667H13.8L13.9867 18ZM14.7333 23.3333H9V22H14.5467L14.7333 23.3333ZM15.2933 27.3333L15.48 28.6667H9V27.3333H15.28H15.2933Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11349_21523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2CEcom);
export default __webpack_public_path__ + "static/media/d2c-ecom.6ec21b9e130f05a7fded9e30a0c2d454.svg";
export { ForwardRef as ReactComponent };